import { h } from 'preact'
import { Item, SubItem } from './types'

const GroupedListItem = ({ item } : { item : SubItem }) =>
  <div class='list-item' data-value={item.value} onClick={item.onClick}>{item.title}</div>

const GroupedList = ({ items } : { items: Item[]}) =>
  <div class='list'>
    {items.map(item => <div>
      <div className='list-item list-item-group-name'>{item.groupName}</div>
      {item.items.map(item => <GroupedListItem item={item} />)}
    </div>)}
  </div>

export default GroupedList
